// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>('/api/currentUser', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/login/outLogin', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/login/account', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 刷新Token POST /api/refreshToken */
export async function refreshToken(
  params: {
    refresh_token: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    access_token: string;
    refresh_token: string;
    expires_in: number;
  }>('/api/refreshToken', {
    method: 'POST',
    data: params,
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}

// ==================== 操作台相关接口 ====================

/** 获取超级管理员操作台数据 GET /api/dashboard/operation-desk/admin */
export async function getAdminOperationDeskData(options?: { [key: string]: any }) {
  return request<EducationOperationDeskData>('/api/dashboard/operation-desk/admin', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取教育部操作台数据 GET /api/dashboard/operation-desk/ministry */
export async function getMinistryOperationDeskData(options?: { [key: string]: any }) {
  return request<EducationOperationDeskData>('/api/dashboard/operation-desk/ministry', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 教委端操作台数据结构 */
export interface EducationOperationDeskData {
  /** 统计卡片：所有媒体内容、当年媒体内容、当年已处理预警、当年已处理异常、所有已处理预警、待教委处理预警、待院校处理异常、待教委处理审批 */
  statistics: Array<{ title: string; value: string | number; suffix?: string }>;
  /** 媒体内容走势 近7日 xAxis + data */
  mediaTrend: { xAxis: string[]; data: number[] };
  /** 预警内容走势 近7日 */
  warningTrend: { xAxis: string[]; data: number[] };
  /** 预警内容院校排行 */
  schoolRankingByWarning: Array<{ rank: number; schoolName: string; count: number }>;
  /** 未处理异常院校排行 */
  schoolRankingByUnhandled: Array<{ rank: number; schoolName: string; count: number }>;
  /** 异常关键词排行 */
  keywordRanking: Array<{ rank: number; keyword: string; count: number }>;
  /** 媒体内容来源 柱状图：type + count + percent */
  mediaSourceChart: Array<{ type: string; count: number; percent: number }>;
  /** 预警内容来源 柱状图（状态：忽略异常+待审批） */
  warningSourceChart: Array<{ type: string; count: number; percent: number }>;
  /** 预警内容处理状态 柱状图：无异常预警、待院校处理异常、待教委处理预警、处理通过 */
  warningStatusChart: Array<{ type: string; count: number; percent: number }>;
  /** 最新通知（与院校端同源） */
  notifications: Array<{ title: string; time: string; type: string }>;
  /** 帮助文档（与院校端同源） */
  helpDocuments: Array<{ title: string; url: string }>;
}

/** 获取教委端操作台数据 GET /api/dashboard/operation-desk/education */
export async function getEducationOperationDeskData(options?: { [key: string]: any }) {
  return request<EducationOperationDeskData>('/api/dashboard/operation-desk/education', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 院校端操作台数据结构 */
export interface SchoolOperationDeskData {
  statistics: Array<{ title: string; value: string | number; suffix?: string }>;
  chartData: { xAxis: string[]; data: number[] };
  notifications: Array<{ title: string; time: string; type: string }>;
  helpDocuments: Array<{ title: string; url: string }>;
}

/** 获取院校端操作台数据 GET /api/dashboard/operation-desk/school */
export async function getSchoolOperationDeskData(options?: { [key: string]: any }) {
  return request<SchoolOperationDeskData>('/api/dashboard/operation-desk/school', {
    method: 'GET',
    ...(options || {}),
  });
}
